export const ITEM_TYPE_NODE_CONTENT = 'formNodeContent';
export const ITEM_TYPE_NODE_FOOT = 'formNodeFoot';
export const ITEM_TYPE_NODE_RESPONSE_OPTION = 'formNodeResponseOption';
